__turbopack_context__.v({
  "cart-total-items": "UsYADG_cart-total-items",
  "cartQty": "UsYADG_cartQty",
});
